<template>
    <solid-box title="成交公告">
        <table-info :columns="columns" :table-data="tableData" />
    </solid-box>
</template>

<script>
import TableInfo from '@/components/TableInfo'
import * as fcScreenAPI from '@/api/fc-screen'
import SolidBox from '@/components/SolidBox'

/**
 * 成交公告
 */
export default {
    components: {
        TableInfo,
        SolidBox
    },
    data() {
        return {
            columns: [
                { title: '项目名称', field: 'title', width: '40%' },

                { title: '成交价格', field: 'price', type: 'emphasize' },
                { title: '成交时间', field: 'time' }
            ],
            tableData: []
        }
    },
    methods: {
        async getProjectList() {
            const params = {
                fNodeId: 15117,
                page: 1,
                rows: 40
            }
            const response = await fcScreenAPI.getDealNoticeList(params)
            if (response && response.data.length) {
                this.tableData = response.data
                for (let i = 0; i < this.tableData.length; i++) {
                    this.tableData[i].title = this.tableData[i].contractLandName
                    this.tableData[i].time = this.tableData[i].fPublishDate
                        .split('.')
                        .join('-')
                    this.tableData[i].price = this.tableData[i].unitPrice
                }
            }
        }
    },
    mounted() {
        this.getProjectList()
    }
}
</script>

<style></style>
